import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { vehicleService } from '../../../application/VehicleService';
import { Vehicle } from '../../../domain/vehicle/Vehicle';
import { useRetrieveActiveLanguage } from '../../../hooks/translations/useRetrieveActiveLanguage';

interface UseUpdateVehicleLocationProps {
  location: { lat: number; lng: number };
}

type UseUpdateVehicleLocationResponseProps = ServiceResponse<
  ({ location }: UseUpdateVehicleLocationProps) => void,
  Vehicle
>;

// Hooks act as 'Adapter' layer.
export const useUpdateVehicleLocation = (): UseUpdateVehicleLocationResponseProps => {
  const { activeLanguage } = useRetrieveActiveLanguage();
  const queryClient = useQueryClient();

  const { isLoading, isError, isSuccess, mutate } = useMutation(
    ({ location }: UseUpdateVehicleLocationProps) => {
      return vehicleService.updateRegisterLocation({
        ...location,
        lang: activeLanguage,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`drivers_vehicle`]);
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: mutate,
  };
};
